(function () {
  'use strict';

  function versRequete(saisie) {
    var mots = saisie.replace(/€/g, ' Euro ').trim().split(/\s+/).filter(Boolean);
    if (!mots.length) return '';
    return mots.map(function (m) { return 'title:' + m; }).join(' AND ');
  }

  function versTexteLisible(valeur) {
    if (!valeur) return valeur;
    var mots = [];
    var trouve = false;
    valeur.replace(/title:(\S+)/g, function (correspondance, mot) {
      trouve = true;
      mots.push(mot);
      return correspondance;
    });
    return trouve ? mots.join(' ') : valeur;
  }

  function nettoyerChamps() {
    document.querySelectorAll('form[role="search"] input[name="q"]').forEach(function (input) {
      input.value = versTexteLisible(input.value);
    });
    document.querySelectorAll('[data-terme-recherche]').forEach(function (el) {
      el.textContent = versTexteLisible(el.textContent);
    });
  }

  document.querySelectorAll('form[role="search"]').forEach(function (form) {
    var input = form.querySelector('input[name="q"]');
    if (!input) return;

    form.addEventListener('submit', function (e) {
      var requete = versRequete(input.value);
      if (!requete) return;

      e.preventDefault();
      var params = new URLSearchParams(new FormData(form));
      params.set('q', requete);
      params.set('type', 'product');
      window.location.assign((form.getAttribute('action') || '/search') + '?' + params.toString());
    });
  });

  /* au chargement, puis une seconde fois au cas où le thème remplirait le champ en retard */
  nettoyerChamps();
  window.addEventListener('load', nettoyerChamps);
})();